module.exports = {"id":"137510","name":"Arnold Kruiswijk","rating":"72","photo":"./data/images/photos/2/137510.png","club":{"name":"Vitesse","logo":"./data/images/clubs/Vitesse.png"},"positions":["DC","DG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ArnoldKruiswijk0.json
// module id = 468
// module chunks = 0